const stages = [
  { time: 'Сразу после обучения', retention: '100%', desc: 'Сотрудник помнит всё, полон энтузиазма и готов применять новые знания.' },
  { time: 'Через 1 день', retention: '~70%', desc: 'Первое столкновение с текучкой: срочные задачи, звонки, письма вытесняют новые знания.' },
  { time: 'Через 1 неделю', retention: '~40%', desc: 'Без практики и повторения большая часть знаний теряется. Сотрудник возвращается к привычным паттернам.' },
  { time: 'Через 2 недели', retention: '~20%', desc: 'Кривая Эббингауза в действии: без внедрения и повторения остаётся не более 20% информации.' },
  { time: 'Через 1 месяц', retention: '~5-10%', desc: 'Без системы сопровождения от обучения остаются только общие впечатления и фрагментарные знания.' },
];

const solutions = [
  { icon: 'ri-repeat-line', title: 'Интервальное повторение', desc: 'Повторение материала через 1 день, 1 неделю, 1 месяц. Каждое повторение закрепляет нейронные связи и переводит знания в долговременную память.' },
  { icon: 'ri-file-list-3-line', title: 'Домашние задания', desc: 'Конкретные задания с дедлайнами после тренинга. Именно практика превращает «я знаю» в «я умею» и «я делаю».' },
  { icon: 'ri-user-star-line', title: 'Наставничество', desc: 'Опытный наставник помогает применять знания в реальных рабочих ситуациях, даёт обратную связь и корректирует ошибки.' },
  { icon: 'ri-feedback-line', title: 'Обратная связь руководителя', desc: 'Регулярные встречи с руководителем для обсуждения прогресса, разбора сложных ситуаций и корректировки плана развития.' },
  { icon: 'ri-database-2-line', title: 'База знаний и чек-листы', desc: 'Доступ к материалам, алгоритмам и чек-листам в любой момент. Шпаргалка, которая всегда под рукой.' },
  { icon: 'ri-line-chart-line', title: 'Промежуточная оценка', desc: 'Замер прогресса на контрольных точках: через 2 недели, 1 месяц, 3 месяца. Цифры мотивируют больше, чем слова.' },
];

export default function WhyEmployeesForget() {
  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Почему сотрудники забывают обучение: кривая забывания
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Без системного подхода 80-90% знаний теряется в течение первых двух недель. Вот как это происходит — и что с этим делать.
        </p>

        <div className="grid lg:grid-cols-2 gap-12">
          <div>
            <h3 className="text-xl font-bold text-gray-900 mb-6">Кривая забывания без сопровождения</h3>
            <div className="space-y-0">
              {stages.map((s, i) => (
                <div key={i} className="relative">
                  <div className="flex items-start gap-4 pb-6">
                    <div className="w-16 flex-shrink-0 text-right">
                      <div className="text-sm text-gray-500">{s.time}</div>
                    </div>
                    <div className="flex-1 bg-white rounded-xl p-4 border border-gray-200">
                      <div className="flex items-center gap-3 mb-1">
                        <span className="text-lg font-extrabold text-teal-600">{s.retention}</span>
                        <span className="text-xs text-gray-400">сохранено знаний</span>
                      </div>
                      <p className="text-sm text-gray-600">{s.desc}</p>
                    </div>
                  </div>
                  {i < stages.length - 1 && (
                    <div className="absolute left-[3.75rem] top-10 bottom-0 w-0.5 bg-teal-200"></div>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-xl font-bold text-gray-900 mb-6">Как остановить забывание: 6 инструментов</h3>
            <div className="space-y-4">
              {solutions.map((s, i) => (
                <div key={i} className="flex gap-4 bg-white rounded-xl p-5 border border-gray-100 hover:border-teal-200 transition-all">
                  <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${s.icon} text-lg text-teal-600`}></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">{s.title}</h4>
                    <p className="text-sm text-gray-600 leading-relaxed">{s.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}